<script setup>
    import __ from '@components/../mixins/locale'
    import axios from 'axios'
    import { ref } from 'vue'

    const props = defineProps({
        redFlag: {
            type: Boolean,
            default () {
                return true
            },
            required: false
        },
        smallBtn: {
            type: Boolean,
            default () {
                return false
            },
            required: false
        },
        namespace: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        userId: {
            type: Number,
            default () {
                return null
            },
            required: false
        },
        contextualId: {
            type: Number,
            default () {
                return null
            },
            required: false
        }
    })

    const user = ref(props.userId);
    
    const context = ref(props.contextualId);

    const feedbackContent = ref('');

    const feedbackGiven = ref(false);

    const loading = ref(false);

    const error = ref(false);

    const submitFeedback = () => {
        if(!feedbackGiven.value){
            loading.value = true;
            axios.post(`/api/feedback`, {
                'userId': user.value,
                'contextualId': context.value,
                'type': props.type,
                'feedback': feedbackContent.value
            }).then(() => {
                feedbackGiven.value = true;
                loading.value = false;
            }).catch((error) => {
                error.value = error.response.data;
                loading.value = false;
            });
        }
    }
</script>

<template>
    <div>
        <div v-if="!redFlag">
            <button type="button" :id="namespace + '-btn'" class="btn btn-primary" data-toggle="modal" :data-target="'#' + namespace + 'modal'">
                <template v-if="type == 'USER_RED_FLAG'">{{ __('Report user!') }}</template>
                <template v-else-if="type == 'STORY_RED_FLAG'">{{ __('Report story!') }}</template>
                <template v-else>{{ __('Report Comment!') }}</template>
            </button>
        </div>
        <div v-else>
            <span v-if="!feedbackGiven" type="button" v-bind:class="{ 'btn-sm float-right': smallBtn }" class="btn btn-danger" v-bind:style="{ margin: smallBtn ? '0 0 15px 15px' : '0' }" data-toggle="modal" :data-target="'#' + namespace + 'modal'">!</span>
            <span v-else class="btn btn-dark" v-bind:style="{ margin: smallBtn ? '0 0 15px 15px' : '0' }">{{ __('We will review your red flag, thank you!') }}</span>
        </div>
        <div class="modal fade" :id="namespace + 'modal'" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content" v-bind:class="[{ 'feedback-given': feedbackGiven }]">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <template v-if="type == 'USER_RED_FLAG'">{{ __('Report user!') }}</template>
                            <template v-else-if="type == 'STORY_RED_FLAG'">{{ __('Report story!') }}</template>
                            <template v-else>{{ __('Report Comment!') }}</template>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span style="color: #fff;text-shadow: none;" aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div v-if="loading" class="loader">
                        <div class="loading-indicator"><div></div><div></div><div></div></div>
                    </div>
                    <div v-else>
                    <div v-if="feedbackGiven && !loading" class="modal-body">
                        <h3>{{ __('We will review your red flag, thank you!') }}</h3>
                    </div>
                    <div v-else class="modal-body">
                        <p v-if="type == 'USER_RED_FLAG'">{{ __('We are sorry to hear that you feel this user is inappropriate, please write a brief description below of your reasons as to help us take appropriate action - thank you!') }}</p>
                        <p v-else-if="type == 'STORY_RED_FLAG'">{{ __('We are sorry to hear that you feel this story is inappropriate, please write a brief description below of your reasons as to help us take appropriate action - thank you!') }}</p>
                        <p v-else>{{ __('We are sorry to hear that you feel this comment is inappropriate, please write a brief description below of your reasons as to help us take appropriate action - thank you!') }}</p>
                        <p v-if="error" style="color: red; font-weight: bold;">{{ error }}</p>
                        <div class="form-group">
                            <textarea class="form-control" id="message-text" v-model="feedbackContent" rows="7"></textarea>
                        </div>
                    </div>
                    <div v-if="!feedbackGiven && !loading" class="modal-footer">
                        <button type="button" v-bind:disabled="feedbackContent === ''" class="btn btn-primary" @click="submitFeedback()">{{ __('Submit Report') }}</button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>